import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getSiteVisitList = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_SITE_VISIT_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/site-visit/list`,
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_SITE_VISIT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_SITE_VISIT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_SITE_VISIT_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const viewSiteVisit = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_SITE_VISIT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(`${BASE_URL}/site-visit/view/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_SITE_VISIT_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_SITE_VISIT_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_SITE_VISIT_FAIL", payload: error.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
